@import "../../theme/global";

lar-button {
  margin: .4rem 0;
}
.radios {
  margin: 0 1rem;
}